<div class="modal fade show custom_popup">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content modal-preview custom-margin">
      <div class="modal-header justify-content-between">
        <h5 class="modal-title">Submit Accounts</h5>
        <div>
          <button type="button" class="close" data-dismiss="modal" (click)="closeProfitDialog()">
            <span>&times;</span>
          </button>
        </div>
      </div>

      <div class="modal-body padding-model form-editing">
        <div class="gap-1 profit-loss">
          <div class="row mt-1">
            <div class="col-md-6 col-lg-6">
              <form [formGroup]="previewForm">
                <label for="balance" class="form-title text-bold p-0 custom-label">Balance Sheet</label>
                <div class="width-170 mb-1 container-grid">
                  <label for="balance" class="form-title text-bold p-0 custom-label custom-label-header text-dark"
                    >Assets</label
                  >

                  <div>
                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label for="totalValue" class="form-title text-nowrap me-2" style="font-weight: bold"
                          >Bank</label
                        >
                        <input
                          class="form-control text-right ft-width inputNumberTextRight"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          formControlName="bank"
                        />
                      </div>
                    </div>

                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label for="totalValue" class="form-title text-nowrap me-2" style="font-weight: bold"
                          >Receivables</label
                        >
                        <input
                          class="form-control text-right ft-width inputNumberTextRight"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          formControlName="receivables"
                        />
                      </div>
                    </div>

                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label for="totalValue" class="form-title text-nowrap me-2" style="font-weight: bold"
                          >Inventory</label
                        >
                        <input
                          class="form-control text-right ft-width inputNumberTextRight"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          formControlName="inventory"
                        />
                      </div>
                    </div>

                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label for="totalValue" class="form-title text-nowrap me-2" style="font-weight: bold"
                          >Other</label
                        >
                        <input
                          class="form-control text-right ft-width inputNumberTextRight"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          formControlName="assetOther"
                        />
                      </div>
                    </div>

                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label for="totalValue" class="form-title text-nowrap me-2" style="font-weight: bold"
                          >Total Current Assets</label
                        >
                        <input
                          class="form-control text-right ft-width inputNumberTextRight disabled"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          [readonly]="true"
                          formControlName="totalCurrentAssets"
                        />
                      </div>
                    </div>

                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label for="totalValue" class="form-title text-nowrap me-2" style="font-weight: bold"
                          >Total Fixed Assets</label
                        >
                        <input
                          class="form-control text-right ft-width inputNumberTextRight"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          formControlName="totalFixedAssets"
                        />
                      </div>
                    </div>

                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label for="totalValue" class="form-title text-nowrap me-2" style="font-weight: bold"
                          >Total Assets</label
                        >
                        <input
                          class="form-control text-right ft-width inputNumberTextRight disabled"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          [readonly]="true"
                          formControlName="totalAssets"
                        />
                      </div>
                    </div>

                    <label
                      for="balance"
                      class="form-title text-bold p-0 mb-2 custom-label custom-label-header text-dark"
                      >Liabilities</label
                    >

                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label for="totalValue" class="form-title text-nowrap me-2" style="font-weight: bold"
                          >Payables</label
                        >
                        <input
                          class="form-control text-right ft-width inputNumberTextRight"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          formControlName="payables"
                        />
                      </div>
                    </div>

                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label for="totalValue" class="form-title text-nowrap me-2" style="font-weight: bold"
                          >Loans</label
                        >
                        <input
                          class="form-control text-right ft-width inputNumberTextRight"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          formControlName="loans"
                        />
                      </div>
                    </div>

                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label for="totalValue" class="form-title text-nowrap me-2" style="font-weight: bold"
                          >Leases</label
                        >
                        <input
                          class="form-control text-right ft-width inputNumberTextRight"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          formControlName="leases"
                        />
                      </div>
                    </div>

                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label for="totalValue" class="form-title text-nowrap me-2" style="font-weight: bold"
                          >VAT</label
                        >
                        <input
                          class="form-control text-right ft-width inputNumberTextRight"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          formControlName="vat"
                        />
                      </div>
                    </div>

                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label for="totalValue" class="form-title text-nowrap me-2" style="font-weight: bold"
                          >PAYE</label
                        >
                        <input
                          class="form-control text-right ft-width inputNumberTextRight"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          formControlName="paye"
                        />
                      </div>
                    </div>

                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label for="totalValue" class="form-title text-nowrap me-2" style="font-weight: bold"
                          >Other</label
                        >
                        <input
                          class="form-control text-right ft-width inputNumberTextRight"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          formControlName="liabilitiesOther"
                        />
                      </div>
                    </div>

                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label
                          for="totalValue"
                          class="form-title text-nowrap me-2 tooltip-ng"
                          placement="top"
                          ngbTooltip="Total Current Liabilities"
                          style="font-weight: bold"
                          >Total Current Liabilities</label
                        >
                        <input
                          class="form-control text-right ft-width inputNumberTextRight disabled"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          [readonly]="true"
                          formControlName="currentLiabilities"
                        />
                      </div>
                    </div>

                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label
                          for="totalValue"
                          class="form-title text-nowrap me-2 tooltip-ng"
                          placement="top"
                          ngbTooltip="Total Non Current Liabilities"
                          style="font-weight: bold"
                          >Total Non Current Liabilities</label
                        >
                        <input
                          class="form-control text-right ft-width inputNumberTextRight"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          formControlName="nonCurrentLiabilities"
                        />
                      </div>
                    </div>

                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label for="totalValue" class="form-title text-nowrap me-2" style="font-weight: bold"
                          >Total Liabilities</label
                        >
                        <input
                          class="form-control text-right ft-width inputNumberTextRight disabled"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          [readonly]="true"
                          formControlName="totalLiabilities"
                        />
                      </div>
                    </div>

                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label for="totalValue" class="form-title text-nowrap me-2" style="font-weight: bold"
                          >Net Assets</label
                        >
                        <input
                          class="form-control text-right ft-width inputNumberTextRight disabled"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          [readonly]="true"
                          formControlName="netAssets"
                        />
                      </div>
                    </div>

                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label for="totalValue" class="form-title text-nowrap me-2" style="font-weight: bold"
                          >Retained Earnings
                        </label>
                        <input
                          class="form-control text-right ft-width inputNumberTextRight"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          formControlName="retainedEarnings"
                        />
                      </div>
                    </div>

                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label for="totalValue" class="form-title text-nowrap me-2" style="font-weight: bold"
                          >Total Equity</label
                        >
                        <input
                          class="form-control text-right ft-width inputNumberTextRight"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          formControlName="totalEquity"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <div class="preview-pagination text-center mt-lg-4">
                <a
                  type="button"
                  class="custom-page-btn"
                  [class.page-btn-disabled]="currentPage === 0"
                  (click)="currentPage > 0 && loadPage(currentPage - 1)"
                >
                  <img alt="" src="../../../../assets/images/icon/previous.svg" width="13px" />
                </a>
                <span> Page {{ currentPage + 1 }} of {{ dataArray.length }} </span>
                <a
                  type="button"
                  class="custom-page-btn"
                  [class.page-btn-disabled]="currentPage === dataArray.length - 1"
                  (click)="currentPage < dataArray.length - 1 && loadPage(currentPage + 1)"
                >
                  <img alt="" src="../../../../assets/images/icon/next.svg" width="13px" />
                </a>
              </div>
            </div>
            <div class="col-md-6 col-lg-6">
              <label for="profit" class="form-title text-bold p-0 custom-label custom-label-header text-dark"
                >Instructions</label
              >
              <p class="res-instructions">
                Enter financial data values in the appropriate fields below. The field ‘Other’ can be used to capture
                any data that cannot be entered in any of the specifically labelled fields.
              </p>

              <form [formGroup]="previewForm_2">
                <label for="profit" class="form-title text-bold p-0 custom-label">Profit & Loss</label>

                <div class="width-170 mb-1 container-grid container-grid-2">
                  <label for="balance" class="form-title text-bold p-0 custom-label custom-label-header text-dark"
                    >Income</label
                  >

                  <div>
                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label
                          for="totalValue"
                          class="form-title text-nowrap me-2 tooltip-ng"
                          placement="top"
                          ngbTooltip="Sales and other Income"
                          style="font-weight: bold"
                        >
                          Sales and other Income</label
                        >
                        <input
                          class="form-control text-right ft-width inputNumberTextRight"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          formControlName="income"
                        />
                      </div>
                    </div>

                    <label for="balance" class="form-title text-bold p-0 custom-label custom-label-header text-dark"
                      >Variable Costs</label
                    >

                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label for="totalValue" class="form-title text-nowrap me-2" style="font-weight: bold"
                          >Materials</label
                        >
                        <input
                          class="form-control text-right ft-width inputNumberTextRight"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          formControlName="materials"
                        />
                      </div>
                    </div>

                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label for="totalValue" class="form-title text-nowrap me-2" style="font-weight: bold"
                          >Labour</label
                        >
                        <input
                          class="form-control text-right ft-width inputNumberTextRight"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          formControlName="labour"
                        />
                      </div>
                    </div>

                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label for="totalValue" class="form-title text-nowrap me-2" style="font-weight: bold"
                          >Other</label
                        >
                        <input
                          class="form-control text-right ft-width inputNumberTextRight"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          formControlName="variablesOther"
                        />
                      </div>
                    </div>

                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label for="totalValue" class="form-title text-nowrap me-2" style="font-weight: bold"
                          >Total</label
                        >
                        <input
                          class="form-control text-right ft-width inputNumberTextRight disabled"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          [readonly]="true"
                          formControlName="variablesTotal"
                        />
                      </div>
                    </div>

                    <label for="balance" class="form-title text-bold p-0 custom-label custom-label-header text-dark"
                      >Fixed Costs</label
                    >

                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label for="totalValue" class="form-title text-nowrap me-2" style="font-weight: bold"
                          >Overhead</label
                        >
                        <input
                          class="form-control text-right ft-width inputNumberTextRight"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          formControlName="overhead"
                        />
                      </div>
                    </div>

                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label for="totalValue" class="form-title text-nowrap me-2" style="font-weight: bold"
                          >Salaries</label
                        >
                        <input
                          class="form-control text-right ft-width inputNumberTextRight"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          formControlName="salaries"
                        />
                      </div>
                    </div>

                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label for="totalValue" class="form-title text-nowrap me-2" style="font-weight: bold"
                          >Interest</label
                        >
                        <input
                          class="form-control text-right ft-width inputNumberTextRight"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          formControlName="interest"
                        />
                      </div>
                    </div>

                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label for="totalValue" class="form-title text-nowrap me-2" style="font-weight: bold"
                          >Tax</label
                        >
                        <input
                          class="form-control text-right ft-width inputNumberTextRight"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          formControlName="tax"
                        />
                      </div>
                    </div>

                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label for="totalValue" class="form-title text-nowrap me-2" style="font-weight: bold"
                          >Other</label
                        >
                        <input
                          class="form-control text-right ft-width inputNumberTextRight"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          formControlName="fixedOther"
                        />
                      </div>
                    </div>

                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label for="totalValue" class="form-title text-nowrap me-2" style="font-weight: bold"
                          >Total</label
                        >
                        <input
                          class="form-control text-right ft-width inputNumberTextRight disabled"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          [readonly]="true"
                          formControlName="fixedTotal"
                        />
                      </div>
                    </div>

                    <div class="mb-1">
                      <div class="d-flex align-items-center">
                        <label for="totalValue" class="form-title text-nowrap me-2" style="font-weight: bold"
                          >Profit</label
                        >
                        <input
                          class="form-control text-right ft-width inputNumberTextRight"
                          type="text"
                          placeholder=""
                          [appOnlyNumber]="true"
                          formControlName="profit"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="d-flex align-items-center mt-2 account-as ms-2">
                  <p style="width: 368px">Accounts as at:</p>
                  <div class="input-group">
                    <app-date-picker id="issuedDate" formControlName="issuedDate" />
                  </div>
                </div>
              </form>
              <div class="d-flex justify-content-end mt-3">
                <button type="button" class="btn btn-light custom-tab-button width-85" (click)="closeProfitDialog()">
                  Cancel
                </button>
                <button
                  type="button"
                  style="background-color: #c5cacb"
                  class="btn btn-light custom-tab-button width-85"
                  (click)="handleProcess()"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
